import React from "react";
import "./App.css";

function HomePage() {
  return (
    <section className="hero hero-home">
      <div className="content">
        <h1 className="title">
          Colorful Choices for Happy Pets
        </h1>

        <div className="sub-line"></div>
      </div>
    </section>
  );
}

export default HomePage;
